class Wishlist {
  constructor() {
    this.storageKey = 'upharkaro_wishlist';
    this.init();
  }

  get() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  has(handle) {
    return this.get().includes(handle);
  }

  add(handle) {
    const list = this.get();
    if (!list.includes(handle)) {
      list.push(handle);
      localStorage.setItem(this.storageKey, JSON.stringify(list));
      this.triggerUpdate();
    }
  }

  remove(handle) {
    let list = this.get();
    list = list.filter(item => item !== handle);
    localStorage.setItem(this.storageKey, JSON.stringify(list));
    this.triggerUpdate();
  }

  toggle(handle) {
    if (this.has(handle)) {
      this.remove(handle);
    } else {
      this.add(handle);
    }
  }

  triggerUpdate() {
    window.dispatchEvent(new CustomEvent('wishlist:updated'));
    this.updateButtons();
    this.updateHeaderBadge();
  }

  updateButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      
      const isActive = this.has(handle);
      if (isActive) {
        btn.classList.add('is-active');
        btn.querySelector('.wishlist-icon-empty').style.display = 'none';
        btn.querySelector('.wishlist-icon-solid').style.display = 'block';
      } else {
        btn.classList.remove('is-active');
        btn.querySelector('.wishlist-icon-empty').style.display = 'block';
        btn.querySelector('.wishlist-icon-solid').style.display = 'none';
      }
    });
  }

  updateHeaderBadge() {
    const counts = document.querySelectorAll('.wishlist-count-bubble span');
    const total = this.get().length;
    counts.forEach(count => {
      count.textContent = total;
    });
    
    const bubbles = document.querySelectorAll('.wishlist-count-bubble');
    bubbles.forEach(bubble => {
      if (total > 0) {
        bubble.style.display = 'flex';
      } else {
        bubble.style.display = 'none';
      }
    });
  }

  init() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        e.preventDefault();
        const handle = btn.dataset.productHandle;
        if (handle) {
          this.toggle(handle);
        }
      }
    });

    // Initial update
    document.addEventListener('DOMContentLoaded', () => {
      this.updateButtons();
      this.updateHeaderBadge();
    });
    
    // In case DOMContentLoaded already fired
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      this.updateButtons();
      this.updateHeaderBadge();
    }
  }
}

window.upharkaroWishlist = new Wishlist();
